module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/logo70d24e7197b2aa790f639db5ae246728.svg";